import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import store, { persistor } from "./globals"
import App from "./app"
import reportWebVitals from "./reportWebVitals"

import "bootstrap/dist/css/bootstrap.min.css"
import "typeface-roboto"
import "./assets/css/theme.css"
import "./assets/css/style.css"
import "./style.css"
import "./index.scss"
/*
	De ultimo a proposito: solo corrige el modo oscuro y tiene que poder ganarle
	a cualquier hoja anterior. No toca el modo claro. */
import "./assets/css/oscuro.css"

import { enableMapSet } from 'immer';
import { PersistGate } from "redux-persist/integration/react"
import ErrorBoundary from "./errorBoundary"
import { startVersionWatcher } from "./versionWatcher"
import { instalarGuardiaDeSesion } from "./guardiaDeSesion"
import { version } from "./version"

enableMapSet();
instalarGuardiaDeSesion()

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render
	(
		<React.StrictMode>
			<Provider store={store}>
				<PersistGate loading={<div>Cargando...</div>} persistor={persistor}>
					<BrowserRouter>
						<ErrorBoundary>
							<App />
						</ErrorBoundary>
					</BrowserRouter>
				</PersistGate>
			</Provider>
		</React.StrictMode >
	)

reportWebVitals()

//Qué versión corre esta pestaña: lo primero que hay que saber cuando alguien reporta "la app vieja".
console.info("WAPP " + version)

startVersionWatcher()
